/**
 * Page-specific configurations for EditorialPage archetypes.
 * Each config controls rendering order and component variants for a specific slug.
 */

export type EditorialSectionKey =
  | "hero"
  | "sectionTitle"
  | "description"
  | "list"
  | "routing";

export type EditorialPageConfig = {
  /** Order in which sections are rendered. Sections not in data are skipped. */
  sectionOrder: EditorialSectionKey[];
  /** Use StillWatching-specific component variants */
  useStillWatchingVariants?: boolean;
};

const defaultConfig: EditorialPageConfig = {
  sectionOrder: ["hero", "sectionTitle", "description", "list", "routing"],
};

const stillWatchingConfig: EditorialPageConfig = {
  sectionOrder: ["hero", "description", "sectionTitle", "list", "routing"],
  useStillWatchingVariants: true,
};

const partnershipsConfig: EditorialPageConfig = {
  sectionOrder: ["hero", "description", "sectionTitle", "list", "routing"],
};

const editorialPageConfigs: Record<string, EditorialPageConfig> = {
  "still-watching": stillWatchingConfig,
  "partnerships": partnershipsConfig,
};

export function getEditorialPageConfig(slug: string | null | undefined): EditorialPageConfig {
  if (!slug) return defaultConfig;
  return editorialPageConfigs[slug.toLowerCase()] ?? defaultConfig;
}
